import { fetchDiscountProduct, fetchDiscountProductDescription, fetchDiscountProductPayments } from './deprecated.api'
import { useQuery } from '@tanstack/react-query'

import { TProduct } from '@/shared/types/product-types'

import { getDiscountCondition } from '../lib/discount-product-format'
import { mapDiscountProductDetailToProduct } from '../lib/map-discount-product-to-product'
import { DiscountProductConditionSpecs, DiscountProductDetail } from '../schema/discount-product-detail.schema'

export type DiscountProductPageData = {
	product: TProduct
	conditionSpecs: DiscountProductConditionSpecs
	discountKod: string
}

export const discountProductKeys = {
	all: ['discount-product'] as const,
	byId: (productId: string) => [...discountProductKeys.all, productId] as const,
	payments: (productId: string) => [...discountProductKeys.byId(productId), 'payments'] as const,
	description: (productId: string) => [...discountProductKeys.byId(productId), 'description'] as const
}

const mapDiscountProductPageData = (detail: DiscountProductDetail): DiscountProductPageData => ({
	product: mapDiscountProductDetailToProduct(detail),
	conditionSpecs: {
		condition: getDiscountCondition(detail.CONDITION) || undefined,
		batterySize: detail.BATTERY_SIZE,
		bundle: detail.BUNDLE
	},
	discountKod: String(detail.DISCOUNT_KOD)
})

export const fetchDiscountProductPageData = async (
	productId: string,
	cookie = ``
): Promise<DiscountProductPageData | null> => {
	const detail = await fetchDiscountProduct(productId, cookie)

	if (!detail) return null

	return mapDiscountProductPageData(detail)
}

export const useDiscountProductQuery = (productId: string, cookie?: string) =>
	useQuery({
		queryKey: discountProductKeys.byId(productId),
		queryFn: () => fetchDiscountProductPageData(productId, cookie),
		enabled: !!productId,
		staleTime: 0,
		gcTime: 0
	})

export const useDiscountProductPaymentsQuery = (productId: string, cookie?: string) =>
	useQuery({
		queryKey: discountProductKeys.payments(productId),
		queryFn: () => fetchDiscountProductPayments(productId, cookie),
		enabled: !!productId,
		staleTime: 0,
		gcTime: 0
	})

export const useDiscountProductDescriptionQuery = (productId: string, cookie?: string) =>
	useQuery({
		queryKey: discountProductKeys.description(productId),
		queryFn: () => fetchDiscountProductDescription(productId, cookie),
		enabled: !!productId,
		staleTime: 0,
		gcTime: 0
	})
